import Config from 'Config';

export const CACHE_KEY_SEP = '|';
export const CACHE_KEY_PREFIX = `catalog-v${Config.version}`;

export default function cacheKey(...comps: string[]) {
  return [CACHE_KEY_PREFIX].concat(comps).join(CACHE_KEY_SEP);
}
